export const getMediaType = (mime: string) => {
  if (mime) {
    return mime.split("/").shift();
  }
};
